<template>
	<div class="cardSlotWrapper">
		<div class="cardSlotHeader">

			<div class="wrap">
				<div class="title">
					<div class="titleWrap">
						<svg-sprite v-if="icon" :icon-id="icon" :width="iconWidth" :height="iconHeight"/>
						<div v-html="title"></div>
					</div>
					<div v-if="isSubTitle" class="subTitle"><slot name="subTitle"></slot></div>
				</div>

				<div class="topButtons">
					<div class="topButtonsWrap">
						<slot name="topButtons"></slot>
					</div>
					<v-btn
							v-if="isAddItem"
							icon
							class="addItem"
							type="button"
							:disabled="!isDisabledAddItem"
							@click="onEvent('addItem')"
					>
						<svg-sprite width="20" height="20" icon-id="addItem" />
					</v-btn>
				</div>
			</div>

		</div>

		<div v-if="$slots.default && $slots.default.length" class="cardSlotBody">
			<div class="wrap">
				<slot />
			</div>
		</div>

		<div v-if="$slots.footer" class="cardSlotFooter">
			<div class="wrap">
				<slot name="footer" />
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: "CardSlot",
	props: {
		title: {
			type: String,
			default: 'Card'
		},
		isSubTitle: Boolean,
		icon: String,
		iconWidth: {
			type: String,
			default: '22px'
		},
		iconHeight: {
			type: String,
			default: '22px'
		},
		isDisabledAddItem: {
			type: Boolean,
			default: true
		},
		isAddItem: Boolean,
	},

	methods: {
		onEvent(flag) {
			this.$emit('updateEvent', flag);
		},
	}
};
</script>

<style scoped lang="scss">
.cardSlotWrapper {
	background: var(--card-bg-opacity);
	display: flex;
	flex-direction: column;
	.cardSlotFooter,
	.cardSlotBody,
	.cardSlotHeader {
		padding: 0 20px;
		> .wrap {
			padding: 20px 0;
		}
	}
	.cardSlotFooter,
	.cardSlotHeader {
		background: var(--card-bg-opacity);
		box-shadow: var(--card-shadow);
	}

	.cardSlotHeader {
		.wrap {
			padding: 10px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.title {
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 10px;
			min-height: 36px;
			.titleWrap {
				font-size: 16px;
				display: flex;
				align-items: center;
				gap: 10px;
				svg {
					color: var(--base-green);
				}
			}
			.subTitle {

			}
		}

		.topButtons {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 16px;
			.topButtonsWrap {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				gap: 16px;
			}
			.addItem {
				svg {
					color: var(--base-green);
				}
			}
		}
	}

	.cardSlotBody {
	}

}
</style>
